import React from 'react';
import { Typography, Image, Space } from 'antd';
import styled from 'styled-components';

const { Title, Text } = Typography;

const StyledSpace = styled(Space)`
  width: 100%;
  position: relative;
  margin-top: 18px;
`;

export const DisplayOnlyBlock = ({
  title,
  description,
  imageUrl,
  imageAlt,
  imageCaption,
  imageHref,
}) => {
  return (
    <>
      <Title level={5}>{title}</Title>
      <div dangerouslySetInnerHTML={{ __html: description }}></div>
      <StyledSpace direction="vertical" size="middle" align="center">
        <a href={imageHref} target="_blank" rel="noreferrer">
          <Image src={imageUrl} alt={imageAlt} preview={false} />
        </a>
        {imageCaption && <Text type="secondary">{imageCaption}</Text>}
      </StyledSpace>
    </>
  );
};

export default DisplayOnlyBlock;
